const doc = [({"da":({"js":({"admin":({"contacts":({"show":({"school_information_card":({"school_information":"Skoleinformation"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;